<template>
  <print-preview @reset="reset" :landscape="landscape">
    <div slot="pages">
      <page
        :styles="styles"
        :default-banner="false"
        class="print-customer-form"
      >
        <template slot="banner">
          <div class="flexRow px-4" style="width: 100%">
            <div
              class="di-flex justify-start"
              style="flex: 1; align-items: center; font-size: 14px"
            >
              <img :src="branch_logo" alt="SO" class="print_logo" />
            </div>
            <div class="di-flex align-center">
              <div class="text-xs-center align-end px-4 font-weight-bold">
                <h4>{{ branch_fa_name }}</h4>
                <h4>{{ LONG_APP_NAME }}</h4>
                <h4>{{ $t("icif") }}</h4>
              </div>
            </div>
            <div class="flex-column align-end" style="flex: 1; font-size: 12px">
              <span>
                <span class="pcf-label">{{ $t("reg_no") }}: </span>
                <span class="pcf-text">{{ customer.id }}</span>
              </span>
              <span>
                <span class="pcf-label">{{ $t("reg_date") }}: </span>
                <span class="pcf-text">{{ customer.created_at }}</span>
              </span>
              <span>
                <span class="pcf-label">{{ $t("persian_date") }}: </span>
                <span class="pcf-text">{{
                  customer.created_at | persianDateFilter(true)
                }}</span>
              </span>
            </div>
          </div>
        </template>

        <template slot="header">
          <th colspan="100%" class="justify-end py-2">
            <!-- <v-divider></v-divider> -->
          </th>
        </template>

        <template slot="body">
          <tr>
            <td
              colspan="100%"
              class="lr--text px-3 body-2 secondary white--text"
            >
              <span class="pcf-label">
                {{ $t("personal_details") }}
              </span>
            </td>
          </tr>
          <tr>
            <td class="lr--text px-3">
              <span class="pcf-label">{{ $t("first_name") }}: </span>
              <span class="mx-2 pcf-text">{{
                customer.individual.first_name
              }}</span>
            </td>
            <td colspan="2" class="lr--text px-3">
              <span class="pcf-label">{{ $t("place_of_birth") }}: </span>
              <span class="mx-2 pcf-text">{{
                customer.individual.place_of_birth
              }}</span>
            </td>
            <td
              rowspan="5"
              class="customer-image"
              style="text-align: center; vertical-align: middle"
            >
              <img :src="customer.individual.image" alt="Image" />
            </td>
          </tr>
          <tr>
            <td class="lr--text px-3">
              <span class="pcf-label">{{ $t("middle_name") }}: </span>
              <span class="mx-2 pcf-text">{{
                customer.individual.middle_name
              }}</span>
            </td>
            <td colspan="2" class="lr--text px-3">
              <span class="pcf-label">{{ $t("date_of_birth") }}: </span>
              <span class="mx-2 pcf-text">{{
                customer.individual.date_of_birth
              }}</span>
            </td>
          </tr>
          <tr>
            <td class="lr--text px-3">
              <span class="pcf-label">{{ $t("last_name") }}: </span>
              <span class="mx-2 pcf-text">{{
                customer.individual.last_name
              }}</span>
            </td>
            <td colspan="2" class="lr--text px-3">
              <span class="pcf-label">{{ $t("gender") }}: </span>
              <span class="mx-2 pcf-text">{{
                customer.individual.gender
              }}</span>
            </td>
          </tr>
          <tr>
            <td class="lr--text px-3">
              <span class="pcf-label">{{ $t("father_name") }}: </span>
              <span class="mx-2 pcf-text">{{
                customer.individual.father_name
              }}</span>
            </td>

            <td colspan="2" class="lr--text px-3">
              <span class="pcf-label">{{ $t("marital_status") }}: </span>
              <span class="mx-2 pcf-text">{{
                customer.individual.marital_status
              }}</span>
            </td>
          </tr>
          <tr>
            <td colspan="3" class="lr--text px-3">
              <span class="pcf-label">{{ $t("current_address") }}: </span>
              <span class="mx-2 pcf-text">{{
                customer.individual.current_address
              }}</span>
            </td>
          </tr>
          <tr>
            <td colspan="3" class="lr--text px-3">
              <span class="pcf-label">{{ $t("permanent_address") }}: </span>
              <span class="mx-2 pcf-text">{{
                customer.individual.permanent_address
              }}</span>
            </td>
            <td colspan="2" class="lr--text px-3">
              <span class="pcf-label">{{ $t("resident_status") }}: </span>
              <span class="mx-2 pcf-text">{{
                $t(customer.individual.resident)
              }}</span>
            </td>
          </tr>
          <tr></tr>
          <tr>
            <td class="lr--text px-3">
              <span class="pcf-label">{{ $t("tazkira_no") }}: </span>
              <span class="mx-2 pcf-text">{{
                customer.individual.tazkira_no
              }}</span>
            </td>
            <td colspan="2" class="lr--text px-3">
              <span class="pcf-label">{{ $t("nationality") }}: </span>
              <span class="mx-2 pcf-text">{{
                customer.individual.nationality
              }}</span>
            </td>
            <td colspan="1" class="lr--text px-3">
              <span class="pcf-label">{{ $t("gov_id") }}: </span>
              <span class="mx-2 pcf-text">{{
                customer.individual.gov_id
              }}</span>
            </td>
          </tr>

          <tr>
            <td class="lr--text px-3">
              <span class="pcf-label">{{ $t("passport_no") }}: </span>
              <span class="mx-2 pcf-text">{{
                customer.individual.passport_no
              }}</span>
            </td>
            <td colspan="2" class="lr--text px-3">
              <span class="pcf-label">{{ $t("issue_date") }}: </span>
              <span class="mx-2 pcf-text">{{
                customer.individual.issue_date
              }}</span>
            </td>
            <td class="lr--text px-3">
              <span class="pcf-label">{{ $t("expire_date") }}: </span>
              <span class="mx-2 pcf-text">{{
                customer.individual.expire_date
              }}</span>
            </td>
          </tr>
          <tr>
            <td colspan="2" class="lr--text px-3">
              <span class="pcf-label">{{ $t("issuer_place") }}: </span>
              <span class="mx-2 pcf-text">{{
                customer.individual.issuer_place
              }}</span>
            </td>
            <td colspan="2" class="lr--text px-3">
              <span class="pcf-label">{{ $t("customer_type") }}: </span>
              <span class="mx-2 pcf-text">{{
                customer.individual.customer_type
              }}</span>
            </td>
          </tr>
          <tr>
            <td colspan="100%" class="white py-2"></td>
          </tr>
          <tr class="mt-2">
            <td
              colspan="100%"
              class="lr--text px-3 body-2 secondary white--text"
            >
              <span class="pcf-label">
                {{ $t("contact_details") }}
              </span>
            </td>
          </tr>
          <tr>
            <td colspan="3" class="lr--text px-3">
              <span class="pcf-label">{{ $t("phones") }}: </span>
              <span class="mx-2 pcf-text">{{
                customer.individual.pretty_phones
              }}</span>
            </td>
            <td class="lr--text px-3">
              <span class="pcf-label">{{ $t("email") }}: </span>
              <span class="mx-2 pcf-text">{{ customer.individual.email }}</span>
            </td>
            <!-- <td class="lr--text px-3">
              <span class="pcf-label">{{ $t("customer_type") }}: </span>
              <span class="mx-2 pcf-text">{{ customer.individual.customer_type }}</span>
            </td> -->
          </tr>

          <tr>
            <td colspan="100%" class="white py-2"></td>
          </tr>
          <tr class="mt-2">
            <td
              colspan="100%"
              class="text-xs-left lr--text px-3 body-2 secondary white--text"
            >
              <span class="pcf-label">
                {{ $t("profession_details") }}
              </span>
            </td>
          </tr>
          
          <tr>
            <!-- <td class="lr--text px-3">
              <span class="pcf-label">{{ $t("business_name") }}: </span>
              <span class="mx-2 pcf-text">{{
                customer.individual.business_name
              }}</span>
            </td>
            <td class="lr--text px-3">
              <span class="pcf-label">{{ $t("nature_of_business") }}: </span>
              <span class="mx-2 pcf-text">{{
                customer.individual.nature_of_business
              }}</span>
            </td> -->
            <td colspan="2" class="lr--text px-3">
              <span class="pcf-label">{{ $t("tin_number") }}: </span>
              <span class="mx-2 pcf-text">{{
                customer.individual.tin_number
              }}</span>
            </td>
            <td colspan="2" class="lr--text px-3">
              <span class="pcf-label">{{ $t("source_of_income") }}: </span>
              <span class="mx-2 pcf-text">{{
                customer.individual.source_of_income
              }}</span>
            </td>
          </tr>
          <tr>
            <td colspan="2" class="lr--text px-3">
              <span class="pcf-label">{{ $t("monthly_income") }}: </span>
              <span class="mx-2 pcf-text">{{
                customer.individual.monthly_income
              }}</span>
            </td>
            <td colspan="2" class="lr--text px-3">
              <span class="pcf-label">{{ $t("monthly_turnover") }}: </span>
              <span class="mx-2 pcf-text">{{
                customer.individual.monthly_turnover
              }}</span>
            </td>
          </tr>
          <tr>
             <td colspan="2" class="lr--text px-3">
              <span class="pcf-label">{{ $t("tenure") }}: </span>
              <span class="mx-2 pcf-text">{{
                customer.individual.tenure
              }}</span>
            </td>
             <td colspan="2" class="lr--text px-3">
              <span class="pcf-label">{{ $t("current_designation") }}: </span>
              <span class="mx-2 pcf-text">{{
                customer.individual.current_designation
              }}</span>
            </td>
          </tr>
          <tr>
            <td colspan="4" class="lr--text px-3">
              <span class="pcf-label">{{ $t("previous_designation") }}: </span>
              <span class="mx-2 pcf-text">{{
                customer.individual.previous_designation
              }}</span>
            </td>
          </tr>
          <tr>
            <td colspan="4" class="lr--text px-3">
              <span class="pcf-label">{{ $t("official_address") }}: </span>
              <span class="mx-2 pcf-text">{{
                customer.individual.official_address
              }}</span>
            </td>
          </tr>
           <tr>
            <td colspan="2" class="lr--text px-3">
              <span class="pcf-label">{{ $t("status") }}: </span>
              <span class="mx-2 pcf-text">{{
                 customer.individual.temporary ? $t("temporary"): $t("permanent")
              }}</span>
               <span
                class="mx-2 pcf-text"
                v-if="customer.individual.sanction_screening"
                >({{ $t("sanction_screening") }})</span
              >
            </td>
            <td colspan="2" class="lr--text px-3">
              <span class="pcf-label">{{ $t("risk_profile") }}: </span>
              <span class="mx-2 pcf-text">{{
                customer.individual.risk_profile
              }}</span>
            </td>
          </tr>
          <tr>
            <td colspan="2" class="lr--text px-3">
              <span class="pcf-label">{{ $t("kyc_updated_date") }}: </span>
              <span class="mx-2 pcf-text">{{
                customer.individual.kyc_updated_date
              }}</span>
            </td>
            <td colspan="2" class="lr--text px-3">
              <span class="pcf-label">{{ $t("next_kyc_date") }}: </span>
              <span class="mx-2 pcf-text">{{
                customer.individual.next_kyc_date
              }}</span>
            </td>
          </tr>
          <!-- <tr>
            <td colspan="100%" class="white pt-3 pb-2 text-xs-left" dir="ltr">
              <p>
                <strong>Undertaking: </strong><br />
                I/we hereby requested {{ LONG_APP_NAME }} to register us
                mentioned above on the basis of the information provided by
                me/us herein. Which I/we confirm is true and correct in all
                aspect. The Registration in {{ LONG_APP_NAME }} will be used for
                bonafide transactions relating to me/our business. I/we agree to
                inform you of any change in the information provided in this
                form with related document. I/we also undertake to abide by the
                requirements of the prevention of money laundering act/Policy in
                force.
                <br />
              </p>
              <hr />
            </td>
          </tr> -->
          <!-- <tr dir="rtl">
            <td colspan="100%" class="white pt-3 pb-2 text-xs-right">
              <p>
                <strong>ژمنه: </strong><br />
                زه/موږ{{ branch_ps_name }} څخه هیله کوو چی د هغه معلوماتو پر
                بنست چه ما/موږ پورته ذکر کری چی زه/موږ یی تائیدوم/ تائید، راته
                راجسټر کړيٕر. همدارنکه ژمنه کوم/کوو چی دخپل/اخپلو
                {{ branch_ps_name }} راجستر څخه به په خپلو قانونی او سوداګریزی و
                معلوماتو کی کار اخلم/اخلو او په پورته ذکر شوی معلوماتو کی کار
                اخلم/اخلو او که پورته ژمنه کوم/کوو چی دپیسو د پر یمنځلو څخه
                دمخننوي قانون او مقررات به په نظر کی نیسم/نیسو.
                <br />
              </p>
              <hr />
            </td>
          </tr> -->
          <tr dir="rtl">
            <td colspan="100%" class="white pt-3 pb-2 text-xs-right">
              <p>
                <strong>تعهدنامه: </strong><br />
                بدین وسیله از {{ branch_fa_name }} در خواست مینمایم/مینماییم تا
                به اساس معلومات ارایه شده که از آن اطمینان کامل میدهم/میدهیم که
                من/ما را ثبت نام نمایند. ثبت نام در {{ branch_fa_name }} با حسن
                نیت برای پیشبرد معاملات /تجارتی من/ما استفاده خواهد شد همچنان
                تعهد می سپارم/ می سپاریم که از ثبت نام در
                {{ branch_fa_name }} را برای معاملات قانونی و تجاری خویش استفاده
                نمایم/ نماییم و در صورت هرنوع تغیر و تبدیلی در معلومات ارایه شده
                فوق به خدامات پولی را مطلع سازم/سازیم تعهد مینمایم/مینماییم که
                مقررات و پالیسی نافذه قانون تطهیر پولی را در نظر گیرم/گیریم.
              </p>
              <!-- <hr /> -->
            </td>
          </tr>

          <tr>
            <td class="pt-5 pb-3 white" colspan="4">
              <strong
                >{{ $t("customer_sign") }} :
                __________________________________</strong
              >
            </td>
          </tr>
          <tr>
            <td colspan="100%" class="lr--text px-3 white pt-3 pb-2">
              <p>
                <span class="primary--text px-2 font-weight-bold"
                v-if="customer.individual.is_pep">(PEP)</span>
                <strong>{{ $t("kyc_notes") }} </strong><br />
                {{ customer.individual.kyc_notes }}
              </p>
            </td>
          </tr>
          <tr>
            <td colspan="100%" class="rlr-border pt-3 page-break"></td>
          </tr>
          <tr>
            <td class="pt-1 pb-3" colspan="2">
              <strong>CIF Processed By </strong>
            </td>
            <td class="pt-2 pb-3">
              <strong>Date <br />{{ customer.created_at }}</strong>
            </td>
            <td class="pt-2 pb-3">
              <strong>Sign</strong>
            </td>
          </tr>

          <tr>
            <td colspan="100%" class="rlr-border pt-1"></td>
          </tr>
          <tr>
            <td class="pt-2 pb-3" colspan="2">
              <strong>CIF Verified By </strong>
            </td>
            <td class="pt-2 pb-3">
              <strong>Date <br />{{ customer.created_at }}</strong>
            </td>
            <td class="pt-2 pb-3">
              <strong>Sign</strong>
            </td>
          </tr>

          <tr>
            <td colspan="100%" class="rlr-border pt-1"></td>
          </tr>
          <tr>
            <td class="pt-2 pb-3 flex align-content-end" colspan="2">
              <strong>Compliance Verification By </strong>
            </td>
            <td class="pt-2 pb-3">
              <strong>Date <br /></strong>
            </td>
            <td class="pt-2 pb-4">
              <strong>Sign</strong>
            </td>
          </tr>
        </template>
      </page>
    </div>
  </print-preview>
</template>

<script>
import get from "lodash/get";
import { mapGetters } from "vuex";

export default {
  data: () => ({
    loading: false,
    customer: {
      type: "individual",
      is_bank: false,
      individual: {
        first_name: "",
        middle_name: "",
        last_name: "",
        father_name: "",
        date_of_birth: new Date().toLocaleDateString("en-ca"),
        place_of_birth: "",
        gender: "Male",
        marital_status: "Single",
        current_address: "",
        permanent_address: "",
        resident: "resident",
        doctype: "passport",
        nationality: "",
        tazkira_no: "",
        passport_no: "",
        issuer_place: "",
        issue_date: "",
        expire_date: "",
        phones: [],
        email: "",
        nature_of_business: "",
        source_of_income: "",
        monthly_income: "",
        monthly_turnover: "",
        tin_number: "",
        tenure: "",
        risk_profile: "",
        kyc_notes: "",
        kyc_updated_date: new Date().toLocaleDateString("en-ca"),
        next_kyc_date: "",
        current_designation: "",
        previous_designation: "",
      },
    },
  }),
  computed: {
    items() {
      return this.dailyReport.items;
    },

    landscape() {
      return false;
    },

    styles() {
      if (this.landscape) return { "min-height": "200mm", width: "290mm" };
      return { "min-height": "280mm", width: "200mm" };
    },
  },
  created() {
    let id = this.$store.state.route.params.id;
    if (id) {
      this.axios
        .get(`customers/${id}?type=individual`)
        .then((response) => {
          this.customer = response.data.data;
          this.correct_route = true;
          this.loading = false;
        })
        .catch((error) => {
          this.correct_route = false;
          this.loading = false;
        });
    }
  },
  methods: {
    reset() {
      this.$router.go(-1);
    },
  },
};
</script>